import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { CalendarEvent } from "../Common/types";
import {
  Box,
  Link,
  Tooltip,
  Text,
  useColorModeValue,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useToast,
  Button,
  useBreakpointValue,
  Heading,
  HStack,
  VStack,
} from "@chakra-ui/react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { Tutor } from "../Common/types";
import { toUtcISOString, parseUtc, fmtLocal } from "../../utils/dates";

// Initialize the localizer with Moment.js
const localizer = momentLocalizer(moment);

interface TokenPayload {
  sub: string;
  role_id: number;
  tenant_id: number;
  exp?: number;
}


const TutorCalendar = () => {
  const [events, setEvents] = useState<CalendarEvent[]>([]);

  const [currentTutor, SetCurrentTutor] = useState<Tutor>();

  const toast = useToast();
  const tableHeaderBg = useColorModeValue("teal.100", "teal.700");
  const calendarBg = useColorModeValue("teal.50", "teal.700");
  const buttonBg = useColorModeValue("red.500", "red.700");
  const textColor = useColorModeValue("teal.800", "teal.50");
  const bannerColor = useColorModeValue("yellow.100", "yellow.700");

  const showBanner = useBreakpointValue({ base: false, md: true }); // Hide footer on smaller screens


  // Fetch events from your backend API
  useEffect(() => {

    const fetchCurrentTutor = async () => {
      try {
      const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";
        
        const response = await axios.get(apiurl + `/tutor`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        // Assuming the API returns events in the required format
        SetCurrentTutor(response.data);
      } catch (error) {
        console.error("Error fetching Tutor Info:", error);
      }
    };
  

/*     const fetchEvents = async () => {
      try {
        // const response = await fetch(API_URL);
        // const data = await response.json();

        const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";
        
        const response = await axios.get(apiurl + `/tutors/calendar-events/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        const data = response.data;
        // Assuming the API returns events in the required format
        setEvents(
          data.map((event: any) => ({
            ...event,
            start: new Date(event.start), // Ensure dates are parsed correctly
            end: new Date(event.end),
          }))
        );
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    }; */

        /* …inside your component … */
        const fetchEvents = async () => {
          try {
            const apiurl =
              process.env.REACT_APP_API_URL || "https://default-url.com";
    
            const { data } = await axios.get(
              `${apiurl}/tutors/calendar-events/`,
              {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
              },
            );
    
            /* 1️⃣  map → parse timestamps correctly
              2️⃣  sort by start time (oldest-first) */
            const events = data
              .map((ev: any) => ({
                ...ev,
                start: parseUtc(ev.start), // true UTC → Date
                end:   parseUtc(ev.end),
              }))
              .sort((a: any, b: any) => a.start.getTime() - b.start.getTime());
    
            setEvents(events);
          } catch (error) {
            console.error("Error fetching events:", error);
          }
        };
    

    fetchEvents();
    fetchCurrentTutor();
  }, []);

  // Custom event rendering
  const EventComponent = ({ event }: { event: CalendarEvent }) => {
    const bgColor = useColorModeValue("teal.100", "teal.900");
   
    const textColor = useColorModeValue("teal.800", "teal.50");

    return (
      <Tooltip label={event.type} aria-label={`${event.type} tooltip`}>
        <Box
          bg="blue.200"
          color="blue.900"
          p={2}
          borderRadius="sm"
          textAlign="center"
        >
          <Link href={event.link} isExternal>
            <Text fontWeight="bold">{event.title}</Text>
          </Link>
        </Box>
      </Tooltip>
    );
  };

  return (

    <Box>
      {showBanner && (
      <Box bgColor={bannerColor} p={4} height={"70px"}>
        <HStack>
          <Heading size={"sm"}>Hello  {currentTutor?.given_name} !</Heading>
          <Text  fontWeight={"normal"} fontSize={"md"}>Checkout your calendar for Classes, Assignments and Tests.</Text>      
          </HStack>
      </Box>
      )}
      {!showBanner && (
      <Box p={4} bgColor={bannerColor} height={"50px"}>
        <VStack>
          <Text  fontWeight={"semibold"} fontSize={"md"}>My Calendar</Text>      
          </VStack>
      </Box>
      )}
      <Box as="main" mx="auto" maxWidth={"1200px"} color="black">

      <Box mt={10} p={6} borderRadius={"md"} bgColor="gray.300" boxShadow={"2xl"} >
        <Calendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 500 }}
          components={{
            event: EventComponent, // Custom rendering for events
          }}
          views={["month", "week", "day"]}
          defaultView="month"
        />
      </Box>
  </Box>
  </Box>
  );
};

export default TutorCalendar;
